import type { Decimal } from '@snap-types/types/decimal';

import type { LeadTimeCalculatorInput } from './input';
import { runConstantValueStrategy } from './strategies/constant-value';
import { runPlanningLeadTimeStrategy } from './strategies/planning-lead-time';
import { runQuantityAwareStrategy } from './strategies/quantity-aware';
import { runRAFFixedMarketStrategy } from './strategies/raf-fixed-market';
import type { LeadTimeStrategy, LeadTimeStrategyResult } from './types';

export function runStrategy(
  quantity: Decimal,
  strategy: LeadTimeStrategy,
  input: LeadTimeCalculatorInput,
): LeadTimeStrategyResult {
  const name = strategy.name;

  switch (name) {
    case 'ConstantValue':
      return runConstantValueStrategy(strategy, input);

    case 'PlanningLeadTime':
      return runPlanningLeadTimeStrategy(strategy, input);

    case 'RAFFixedMarket':
      return runRAFFixedMarketStrategy(strategy, input);

    case 'QuantityAware':
      return runQuantityAwareStrategy(quantity, strategy, input);

    /* v8 ignore next 4 */
    default: {
      const exhaustive: never = name;
      throw new Error(`Unhandled lead time strategy: ${exhaustive}`);
    }
  }
}
